import { markOwnerRoomsMergeDoneUrl } from "./api-url.constants";
import { jsonFetch } from "@/lib/helpers";

export interface MarkMergeDoneResponse {
  updated: number;
}

export const markOwnerRoomsMergeDone = async (ownerId: string): Promise<MarkMergeDoneResponse> => {
  return jsonFetch<MarkMergeDoneResponse>(markOwnerRoomsMergeDoneUrl(ownerId), {
    method: "POST",
  });
};
